import {
	LICENSED_PRODUCTS,
	getLicensedProducts,
} from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';

const hasJswJsd = (): boolean => {
	const products = getLicensedProducts();
	const { JIRA_SOFTWARE, JIRA_SERVICEDESK } = LICENSED_PRODUCTS;
	return products[JIRA_SOFTWARE] && products[JIRA_SERVICEDESK];
};

export default hasJswJsd;
